// Plan[Index] Color
const plan1Color = "#f47521" //"#70AD47"
const plan1ColorLight = "#f69660" //"#86bb63"

const plan2Color = "#4dbeee"
const plan2ColorLight = "#7dcFF2"//"#7194d2"

const plan3Color = "#8ebf3f"
const plan3ColorLight = "#A6CC66"

const disabledColor = "#b7b9bc"

const darkFontColor = '#474c55'

const PlanColors = {
  plan1: {
    "background-color": `${plan1Color} !important`,
    color: "white !important"
  },
  plan2: {
    "background-color": `${plan2Color} !important`,
    color: "white !important"
  },
  plan3: {
    "background-color": `${plan3Color} !important`,
    color: "white !important"
  },
  disabled: {
    backgroundColor: `${disabledColor} !important`,
    color: `white !important`
  }
}

const Fonts = {
  dark: {
    color: `${darkFontColor} !important`
  },
  medium: {
    fontWeight: '500'
  }
}

const LinearPlanColors = {
  plan1: {
    backgroundColor: `${plan1Color} !important`,
    //"background": `linear-gradient(180deg, ${plan1Color}, ${plan1Color}) !important`,
    color: "white !important"
  },
  plan1light: {
    backgroundColor: `${plan1ColorLight} !important`,
    color: "white !important"
  },
  plan2: {
    backgroundColor: `${plan2Color} !important`,
    //"background": `linear-gradient(180deg, ${plan2Color}, ${plan2Color}) !important`,
    color: "white !important"
  },
  plan2light: {
    backgroundColor: `${plan2ColorLight} !important`,
    color: "white !important"
  },
  plan3: {
    backgroundColor: `${plan3Color} !important`,
    //"background": `linear-gradient(180deg, ${plan3Color}, ${plan3Color}) !important`,
    color: "white !important"
  },
  plan3light: {
    backgroundColor: `${plan3ColorLight} !important`,
    color: "white !important"
  },
}

const Overflow = {
  overflower: {
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden"
  }
}

export {PlanColors, LinearPlanColors, Overflow, Fonts}
